import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512">
      <path
        fill="none"
        stroke="#131313"
        stroke-width="20"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="
	M383.243,262.087v-27.328c6.538-1.818,12.793-4.303,18.621-7.503l19.293,19.293c1.649,1.649,4.323,1.649,5.972,0l27.854-27.853
	c1.649-1.649,1.649-4.323,0-5.972l-19.059-19.059c3.34-5.861,6.022-12.131,7.949-18.737h26.933c2.332,0,4.223-1.891,4.223-4.223
	v-39.391c0-2.332-1.891-4.223-4.223-4.223h-26.59c-1.849-6.731-4.416-13.158-7.725-19.138l18.777-18.777
	c1.649-1.649,1.649-4.323,0-5.972L427.415,55.35c-1.649-1.649-4.323-1.649-5.972,0L402.8,73.993
	c-5.983-3.383-12.402-6.055-19.153-7.967V39.527c0-2.332-1.891-4.223-4.223-4.223h-39.391c-2.332,0-4.223,1.891-4.223,4.223v26.5
	c-6.711,1.901-13.095,4.55-19.047,7.904l-18.867-18.867c-1.649-1.649-4.323-1.649-5.972,0L264.07,82.918
	c-1.649,1.649-1.649,4.323,0,5.972l18.961,18.961c-3.271,5.891-5.829,12.211-7.682,18.835h-27.102"
      />
      <circle fill="none" stroke="#131313" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="362.345" cy="151.48" r="30.416" />
      <path
        fill="none"
        stroke="#131313"
        stroke-width="20"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="10"
        d="
	M337.39,284.524h-35.806c-2.49-9.064-5.946-17.719-10.402-25.771l25.286-25.286c2.221-2.221,2.221-5.822,0-8.042l-37.508-37.508
	c-2.22-2.22-5.822-2.22-8.042,0l-25.106,25.106c-8.057-4.555-16.7-8.154-25.792-10.729v-35.684c0-3.141-2.546-5.687-5.687-5.687
	h-53.045c-3.141,0-5.687,2.546-5.687,5.687v35.686c-9.037,2.56-17.634,6.127-25.649,10.644l-25.407-25.407
	c-2.221-2.22-5.822-2.22-8.042,0L58.994,225.04c-2.22,2.221-2.22,5.822,0,8.042l25.534,25.534
	c-4.404,7.932-7.849,16.444-10.345,25.363H37.687c-3.141,0-5.687,2.546-5.687,5.687v53.045c0,3.141,2.546,5.687,5.687,5.687h36.679
	c2.516,8.778,5.978,17.142,10.346,24.954l-26.102,26.102c-2.221,2.22-2.221,5.822,0,8.042l37.508,37.508
	c2.221,2.221,5.822,2.221,8.042,0l26.095-26.094c7.767,4.347,16.079,7.804,24.803,10.321v37.081c0,3.141,2.546,5.687,5.687,5.687
	h53.045c3.141,0,5.687-2.546,5.687-5.687v-36.8c8.804-2.448,17.228-5.795,25.076-10.103l25.98,25.98
	c2.221,2.221,5.822,2.221,8.042,0l37.508-37.508c2.221-2.221,2.221-5.822,0-8.042l-25.666-25.666
	c4.498-7.892,8.109-16.336,10.704-25.231h36.269c3.141,0,5.687-2.546,5.687-5.687v-53.045
	C343.077,287.07,340.531,284.524,337.39,284.524z"
      />
      <circle fill="none" stroke="#131313" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="191.334" cy="317.367" r="40.959" />
    </svg>
  );
};

export default Icon;
